/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { connect } from "react-redux";
import DataTable from "../../../Components/DataTable/DataTable";
import { Button } from "../../../Components/Forms";
import { alertBox, retrieveFromStorage } from "../../../Components/Functions";
import Layout from "../../../Components/Layout";
import { loggedUser } from "../../../Constants/menus";
import { timeIntervals, isABiggerThanB, to12hr } from "../../../Helpers/timeIntervals";
import {
	updateAppointsFilters,
	updateRecords,
} from "../../../Redux/MyAppointments/actions";
import { openPanel } from "../../../Redux/Panels/RightPanel/actions";
import { USER_AUTHENTICATION_DATA } from "../../../Redux/User/types";
import Api from "../../../Server/Api";

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA) || {};
const api = new Api();

const days = [
	{ short: "mon", full: "Monday" },
	{ short: "tue", full: "Tuesday" },
	{ short: "wed", full: "Wednesday" },
	{ short: "thu", full: "Thursday" },
	{ short: "fri", full: "Friday" },
	{ short: "sat", full: "Saturday" },
	{ short: "sun", full: "Sunday" },
];

export const MyAppointmentItem = (props) => {
	return (
		<>
			<td style={{ fontWeight: "bold" }}>
				{days.find((e) => e.short === props?.data?.day)?.full ||
					props?.data?.day}
			</td>
			<td>
				<span className={`tag is-success`} style={{ fontWeight: "bold" }}>{to12hr(props?.data?.start_time)}</span>
			</td>
			<td>
				<span className={`tag is-danger`} style={{ fontWeight: "bold" }}>{to12hr(props?.data?.end_time)}</span>
			</td>
			<td>
				<button
					className={`button h-button is-primary is-outlined is-pushed-mobile`}
					onClick={() => {
						props?.parent?.openPanel({
							title: "Scheduler",
							content: SchedulerModal2({
								data: props?.data,
								callback: props.callback(),
							}),
						});
					}}
				>
					Edit
				</button>
				<button
					className={`ml-2 button h-button is-danger is-pushed-mobile`}
					onClick={() => {
						alertBox({
							title: "Delete",
							message: "Are you sure you want to delete this schedule?",
							btnCallback: "Yes, Delete",
							callback: () => props?.deleteMe(props?.data?.id),
						});
					}}
				>
					Delete
				</button>
			</td>
		</>
	);
};

export const SchedulerModal = (props) => {
	const [data, setData] = React.useState({ ...props?.data });
	const [message, setMessage] = React.useState();

	const getData = () => {
		return { ...data, day: data?.day || window.scheduler_day };
	};

	const timeIntervalList = useMemo(() => timeIntervals(), []);

	React.useEffect(() => {
		// eslint-disable-next-line no-undef
		bulmaCalendar.attach("#bulma-datepicker-3", {
			displayMode: "inline",
			startDate: new Date(),
			lang: "en",
		});
		// eslint-disable-next-line no-undef
		bulmaCalendar.attach("#bulma-datepicker-4", {
			displayMode: "inline",
			startDate: new Date(),
			lang: "en",
		});
	}, []);

	const saveSchedule = () => {
		setMessage(undefined);

		if (data?.day && data?.start_time && data?.end_time) {
			if (isABiggerThanB(data?.start_time, data?.end_time)) {
				setMessage("Start time must be less than end time");
				return;
			}
			api
				.post({ endpoint: `users/${user?.username}/scheduler/`, data: data })
				.then(() => {
					props.callback && props.callback();
				});
		} else {
			setMessage("Please select a day, start time and stop time to continue.");
		}
	};

	return (
		<div className="form-body p-5" style={{ paddingTop: 0 }}>
			{/*Fieldset*/}
			<style>
				{`
					.time-selector {
						width: 50%;
					}
					.datetimepicker-footer {
						display: none !important;
					}
				`}
			</style>
			<div className="form-fieldset">
				<div className="columns is-multiline gh mb-5">
					{message && (
						<div className={`message mb-5 is-${"danger"} w-100`}>
							<div
								className="message-body w-100"
								dangerouslySetInnerHTML={{ __html: message }}
							/>
						</div>
					)}
					<div className="field" style={{ width: "100%" }}>
						<div className="select" style={{ width: "100%" }}>
							<select
								style={{ width: "100%" }}
								onChange={(e) => {
									setData({ ...data, day: e.target.value });
									window.scheduler_day = e.target.value;
								}}
								defaultValue={data?.day}
							>
								<option>Pick a Day</option>
								{days.map((d) => {
									return <option value={d.short}>{d.full}</option>;
								})}
							</select>
						</div>
					</div>
					<div className="field" style={{ width: "100%" }}>
						<div className="select" style={{ width: "100%" }}>
							<select
								style={{ width: "100%" }}
								onChange={(e) => {
									setData({ ...data, start_time: e.target.value });
								}}
								defaultValue={data?.start_time}
							>
								<option>Start time</option>
								{timeIntervalList.map(({ value, label }, i) => {
									return (
										<option 
											key={`start-time-${i}`} 
											value={value}
										>
											{label}
										</option>
									);
								})}
							</select>
						</div>
					</div>
					<div className="field" style={{ width: "100%" }}>
						<div className="select" style={{ width: "100%" }}>
							<select
								style={{ width: "100%" }}
								onChange={(e) => {
									setData({ ...data, end_time: e.target.value });
								}}
								value={data?.end_time}
							>
								<option>End time</option>
								{timeIntervalList.map(({ value, label }, i) => {
									return (
										<option 
											key={`end-time-${i}`} 
											value={value}
										>
											{label}
										</option>
									);
								})}
							</select>
						</div>
					</div>
				</div>

				<div className="columns is-multiline gh mt-5">
					<Button callback={() => saveSchedule()} text="Add Schedule" />
				</div>
			</div>
		</div>
	);
};

export const SchedulerModal2 = (props) => {
	return <SchedulerModal {...props} />;
};

const Schedulers = (props) => {
	const [tableParams, setTableParams] = React.useState({});

	const deleteMe = (id) => {
		api.del({ endpoint: `users/${id}/scheduler/`, data: { id } }).then(() => {
			setTableParams({ ...tableParams, added: (tableParams?.added || 0) + 1 });
		});
	};

	return (
		<Layout
			pageContentClass={"tabs-wrapper is-slider is-squared is-inverted"}
			title={"Scheduler"}
		>
			<div className="page-content-inner xnobg-table">
				<div className="flex-list-wrapper flex-list-v1">
					<div className="flex-table">
						{/*Table header*/}

						<DataTable
							header={[
								{ name: "Day" },
								{ name: "Start" },
								{ name: "Close" },
								{ name: "Actions" },
							]}
							options={{
								allowRemove: false,
								allowBulkSelect: false,
								disableToolBar: false,
								disablePagination: false,
								removeEndPoint: "",
								endpoint: {
									url: `/users/${loggedUser?.username}/scheduler/`,
									params: tableParams,
								},
								left: [],
								right: [
									{
										name: "Add New",
										icon: "fas fa-plus",
										action: () => {
											props.openPanel({
												title: "Scheduler",
												content: SchedulerModal2({
													...props,
													callback: () =>
														setTableParams({
															...tableParams,
															added: (tableParams?.added || 0) + 1,
														}),
												}),
											});
										},
									},
								],
							}}
							renderItem={(e) => {
								return (
									<MyAppointmentItem
										data={e}
										parent={props}
										deleteMe={deleteMe}
										callback={() =>
											setTableParams({
												...tableParams,
												added: (tableParams?.added || 0) + 1,
											})
										}
									/>
								);
							}}
						/>
					</div>
				</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ myappointments }) => {
	return { myappointments };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateAppointsFilters: (e) => dispatch(updateAppointsFilters(e)),
		updateRecords: (e) => dispatch(updateRecords(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(Schedulers); /* eslint-disable jsx-a11y/anchor-is-valid */
